import "./panel.css";
import Header from "../Home/header";
import useFetch from "../Hook/UseFetch";
import { useEffect, useState } from "react";

const Panel = () => {
  useEffect(() => {
    if (
      localStorage.getItem("infos") == null ||
      localStorage.getItem("infos") == {}
    ) {
      window.location.href = "/Login";
    }
  });

  let host = process.env.REACT_APP_HOST;
  console.log(host);
  const { Data: purchase } = useFetch(`${host}/displaypurchase`);
  const { Data: message } = useFetch(`${host}/displaymessage`);

  const [showPurch, setShowPurch] = useState(true);
  const [showMessage, setshowMessage] = useState(false);

  const handlePurchase = () => {
    if (showMessage == true) {
      setshowMessage(false);
      setShowPurch(true);
    }
  };

  const handleMessage = () => {
    if (showPurch == true) {
      setshowMessage(true);
      setShowPurch(false);
      console.log(JSON.stringify(message));
    }
  };

  return (
    <>
      <Header />
      <main>
        {/* <header className="main-head">
          <div className="icons">
            <i className="fa fa-user-md"></i>
            <i className="fa fa-comments-o"></i>
            <i className="fa fa-bell-o">
              <span className="number-alert">3</span>
            </i>
          </div>
          <div className="logout">
            {" "}
            <i className="fa fa-sign-out"></i>
          </div>
        </header> */}
        <div className="containeraw user">
          <div className="user-card">
            <figure>
              <img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/584938/people_10.png" />
            </figure>
            <div className="user-info">
              <div className="name">
                {" "}
                <span>Jane Doe </span>
              </div>
            </div>
          </div>
        </div>

        <div className="wrapper">
          <ul className="category-navigation">
            <li className="active">
              <a
                style={
                  showPurch
                    ? { borderBottom: "4px solid black" }
                    : { borderBottom: "none" }
                }
                onClick={handlePurchase}
              >
                Purchase
              </a>
            </li>
            <li>
              <a
                style={
                  showMessage
                    ? { borderBottom: "4px solid black" }
                    : { borderBottom: "none" }
                }
                onClick={handleMessage}
              >
                Messages
              </a>
            </li>
            {/* <li>
              <a href="#"> board</a>
            </li> */}
          </ul>
          <div className="containeraw">
            <div className="card orange">
              {showPurch && (
                <div className="content visible" data-content="1">
                  <ul>
                    {purchase &&
                      purchase.map((opt) => (
                        <li
                          style={{ borderBottom: "11px solid cornflowerblue" }}
                        >
                          <div>
                            <ul>
                              {" "}
                              <li>{opt.id_user}</li>
                              <li>{opt.fullname}</li>
                              <li>{opt.email}</li>
                              <li>{opt.phone}</li>
                              <li>{opt.contry}</li>
                            </ul>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              )}

              {showMessage && (
                <div className="content visible" data-content="1">
                  <ul>
                    {message &&
                      message.map((opt) => (
                        <li
                          style={{ borderBottom: "11px solid cornflowerblue" }}
                        >
                          <div>
                            <ul>
                              {" "}
                              <li>{opt.id_user}</li>
                              <li>{opt.fullname}</li>
                              <li>{opt.email}</li>
                              <li>{opt.phone}</li>
                              <li>{opt.message}</li>
                            </ul>
                          </div>
                        </li>
                      ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Panel;
